// Энтрипоинт галереи лендинга: CSP режет инлайн-скрипты, поэтому логика едет
// отдельным Vite-бандлом, который вьюха подключает сама (public-layout vite_*_tag
// не зовёт). Вся логика — в lib/gallery.ts.
import { initGallery } from '../lib/gallery'

initGallery()
